/* @ngInject */
function DateCompareDirective() {
    return {
        link: link,
        restrict: 'A',
        require: 'ngModel'
    };

    function link($scope, element, attributes, ngModel) {
        var statesToWatch = [
            attributes.ngModel,
            attributes.egDateCompare
        ];

        $scope.$watchGroup(statesToWatch, function(newValues) {
            var thisDate = newValues[0];
            var otherDate = newValues[1];

            if (!thisDate || !otherDate) {
                ngModel.$setValidity('egDateCompare', true);
                return;
            }

            var thisTime = thisDate.getTime();
            var otherTime = otherDate.getTime();
            var validity;

            switch (attributes.egDateCompareMode) {
                case 'lt':
                    validity = (thisTime < otherTime);
                    break;
                case 'lte':
                    validity = (thisTime <= otherTime);
                    break;
                case 'gt':
                    validity = (thisTime > otherTime);
                    break;
                case 'gte':
                    validity = (thisTime >= otherTime);
                    break;
                default:
                    throw new Error('Unsupported date compare mode: ' + attributes.egDateCompareMode);
            }

            ngModel.$setValidity('egDateCompare', validity);
        });
    }
}

angular.module('egAngularUtils').directive('egDateCompare', DateCompareDirective);